/* ar-catalogue.js — catalogue de comptes en direct du stock fournisseur.
   Sert TOUS les jeux : rien ici ne connait Genshin ni One Piece, tout vient
   du fichier de donnees (schema v2), ecrit par C:\sync-stock\catalogue-<jeu>.mjs.

   Le fichier decrit lui-meme ce qu'il faut afficher :
     icones      prefixe des vignettes, ex. « ar-gi- » ou « ar-op- »
     groupes     rangees de puces exclusives (serveur, plateforme, Traveler...)
     stats       intitules des chiffres d'une carte, dans l'ordre
     tris        options de tri, par indice dans `stats`
     persos      id -> [nom, rarete]
     comptes     [ref, [valeurs de groupe], [stats], [[persoId, niveau]], variantId]

   Reglages lus sur l'element racine :
     data-source   URL du JSON
     data-base     dossier des assets (pour les vignettes)
     data-variant  variante Shopify par defaut
     data-prix     prix par variante, deja formate par Shopify dans la devise
                   du visiteur : {"123456": "€26,95"}
     data-page     nombre de comptes par page                              */

(function () {
  'use strict';
  if (window.__arCatalogue) return;      // price.liquid & co peuvent doubler le <script>
  window.__arCatalogue = true;

  /* Icones de ressources dessinees, pour les jeux dont aucune source publique
     ne diffuse les visuels (One Piece Bounty Rush par exemple). Les jeux qui
     en ont, comme Genshin, declarent « img:<nom> » et une vraie image. */
  var SVG = {
    gem:   '<path d="M6 3h12l4 6-10 12L2 9z" fill="currentColor" opacity=".85"/><path d="M6 3l6 6 6-6M2 9h20" stroke="#fff" stroke-width="1.3" fill="none"/>',
    shard: '<path d="M13 2L4 13h6l-1 9 11-13h-7z" fill="currentColor"/>',
    star6: '<path d="M12 2l2.6 6.3L21 9l-4.8 4.3L17.6 21 12 17.4 6.4 21l1.4-7.7L3 9l6.4-.7z" fill="currentColor"/>',
    star4: '<path d="M12 3l2.2 5.4L20 9l-4.2 3.8L17 20l-5-3.2L7 20l1.2-7.2L4 9l5.8-.6z" fill="currentColor" opacity=".55"/>',
    combo: '<circle cx="8" cy="12" r="5" fill="currentColor" opacity=".55"/><circle cx="16" cy="12" r="5" fill="currentColor"/>',
    level: '<path d="M4 20V10M10 20V4M16 20v-7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" fill="none"/>',
  };

  /* Le script est differe, donc le HTML est deja lu quand il s'execute : on
     demarre sans attendre DOMContentLoaded, qui arrive plus tard. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lancer);
  } else {
    lancer();
  }
  function lancer() { document.querySelectorAll('[data-arc]').forEach(demarrer); }

  function demarrer(racine) {
    var source   = racine.dataset.source;
    var base     = racine.dataset.base || '';
    var vDefaut  = racine.dataset.variant;
    var parPage  = parseInt(racine.dataset.page || '24', 10);
    var prixPar  = {};
    try { prixPar = JSON.parse(racine.dataset.prix || '{}'); } catch (e) { /* prix masques */ }

    var data = null, filtres = [], etat = null;
    /* Lettre du niveau d'un personnage : C (Constellation, Genshin) par defaut, E (Eidolon) pour Star Rail. */
    var lettre = 'C';
    /* Personnages recents (data.recents) : id -> version, id -> rang (0 = le plus neuf). */
    var versionDe = {}, rangRecent = {};

    racine.innerHTML = '<div class="arc__vide">Loading accounts…</div>';

    /* credentials:'omit' fait correspondre cette requete au <link rel=preload
       as=fetch crossorigin> du <head> ; sans cela le fichier partirait deux
       fois. Pas de « no-cache » : l'URL porte deja l'empreinte du fichier. */
    fetch(source, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { data = j; lettre = j.lettre || 'C'; construire(); })
      .catch(function () {
        racine.innerHTML = '<div class="arc__vide">The account list is being updated. Please check back in a few minutes, or contact us on chat.</div>';
      });

    function neuf() {
      return { persos: [], grp: (data.groupes || []).map(function () { return ''; }), tri: 0, page: 1, mini: 0, miniIdx: 0 };
    }

    /* Vignette hebergee chez nous. Si le fichier manque (personnage tout
       juste sorti), l'image se retire et la puce reste lisible en texte. */
    function img(id, classe) {
      if (!base || !data.icones) return '';
      return '<img class="' + classe + '" src="' + base + data.icones + id + '.png" alt="" loading="lazy" decoding="async" width="64" height="64" onerror="this.remove()">';
    }

    /* [0] = nom court, affiche ; [2] = nom complet, mis sur la commande pour
       qu'Elies sache exactement quelle unite livrer. */
    /* La liste de champions d'un compte est soit ecrite en clair, soit un
       numero dans `data.combos`. Le dictionnaire divise le fichier par six
       quand des milliers de comptes partagent la meme composition. */
    function champsDe(c) {
      var h = c[3];
      return (typeof h === 'number') ? ((data.combos || [])[h] || []) : (h || []);
    }

    /* Couleur de cadre telle que le fournisseur la donne. On ne deduit pas
       la rarete nous-memes : aucune source fiable ne l'expose. */
    function couleur(id) { return (data.couleurs || {})[id] || ''; }

    function nom(id)     { var e = data.persos[id]; return e ? e[0] : ('#' + id); }
    function nomLong(id) { var e = data.persos[id]; return e ? (e[2] || e[0]) : ('#' + id); }
    function rarete(id) { var e = data.persos[id]; return e ? e[1] : 0; }
    /* Mise en avant a partir du legendaire. Sur Raid l'echelle est
       7 mythique, 6 legendaire, 5 epique, 4 rare ; ailleurs 5 = cinq etoiles. */
    function haute(id)  { var r = rarete(id); return data.tuiles ? r >= 6 : r >= 5; }

    /* --------------------------------------------------------- rendu */

    function construire() {
      etat = neuf();
      var n = 1;
      var html = '<div class="arc__filtres">' +
        '<p class="arc__etape">' + (n++) + '. ' + (data.armes ? (data.titreDuo || 'Pick your characters and weapons') : (data.titrePersos || 'Pick your character(s)')) + '</p>' +
        /* 07/10/2026 : catalogue Premium — 2e onglet pour filtrer aussi par armes 5 etoiles. */
        (data.armes ? '<div class="arc__onglets" role="tablist"><button type="button" class="arc__onglet" data-onglet="p" aria-pressed="true">Characters</button>' +
                      '<button type="button" class="arc__onglet" data-onglet="a" aria-pressed="false">' + (data.titreArmes || '5★ Weapons') + '</button></div>' : '') +
        '<input type="search" class="arc__chercher" data-chercher placeholder="Search a character" hidden>' +
        '<div class="arc__puces arc__puces--persos" data-persos></div>' +
        (data.armes ? '<input type="search" class="arc__chercher" data-chercher-a placeholder="Search a weapon" hidden>' +
                      '<div class="arc__puces arc__puces--persos arc__puces--longue" data-armes hidden></div>' : '');

      (data.groupes || []).forEach(function (g, i) {
        html += '<p class="arc__etape">' + (n++) + '. ' + g.titre + '</p>' +
                '<div class="arc__puces" data-grp="' + i + '"></div>';
      });

      html += '<div class="arc__ligne arc__ligne--fin">' +
          '<select data-tri aria-label="Sort accounts">' +
            (data.tris || []).map(function (t, i) { return '<option value="' + i + '">' + t[1] + '</option>'; }).join('') +
          '</select>' +
          '<button type="button" class="arc__lien" data-plus>More filters</button>' +
          '<button type="button" class="arc__lien" data-raz hidden>Clear all</button>' +
        '</div>' +
        '<div class="arc__plus" data-panneauplus>' +
          '<label>Minimum ' +
            '<select data-miniidx>' + data.stats.map(function (s, i) { return '<option value="' + i + '">' + s + '</option>'; }).join('') + '</select> ' +
            '<input type="number" data-mini min="0" step="1" placeholder="0">' +
          '</label>' +
        '</div>' +
      '</div>' +
      '<div class="arc__barre"><span class="arc__total" data-total></span><span class="arc__maj" data-maj></span></div>' +
      '<div class="arc__grille" data-grille></div>' +
      /* 15/10/2026 (Elies : « quand je selectionne les personnages je ne vois rien, on dirait une rupture ») :
         sur telephone la liste des persos et les etapes 2-3 repoussent le compteur et les comptes hors de
         l'ecran : un clic ne change rien de visible. Bouton flottant tant que les resultats sont plus bas. */
      '<button type="button" class="arc__voir" data-voir hidden></button>' +
      '<div class="arc__pages" data-pages></div>';

      racine.innerHTML = html;

      /* Personnages, du plus disponible au moins disponible. */
      var dispo = {};
      data.comptes.forEach(function (c) { champsDe(c).forEach(function (p) { dispo[p[0]] = (dispo[p[0]] || 0) + 1; }); });
      /* Quand le fichier trie deja (Raid : mythiques, legendaires, epiques,
         rares), on respecte son ordre. Sinon, du plus disponible au moins. */
      var vedettes = (data.vedettes || []).slice();
      if (!data.tuiles) vedettes.sort(function (a, b) { return (dispo[b] || 0) - (dispo[a] || 0); });
      /* 10/10/2026 : les personnages recents passent en tete, du plus neuf au plus ancien, avec leur
         version (data.recents = [[id, version], ...]). Seulement ceux qui ont au moins un compte. */
      versionDe = {}; rangRecent = {};
      if (data.recents && !data.tuiles) {
        var rec = data.recents.filter(function (r) { return dispo[r[0]]; });
        rec.forEach(function (r, i) { versionDe[r[0]] = r[1]; rangRecent[r[0]] = i; });
        vedettes = rec.map(function (r) { return r[0]; })
          .concat(vedettes.filter(function (id) { return !versionDe[id]; }));
      }

      /* Certains jeux n'ont pas de noms utilisables (Raid : le fournisseur
         ne connait que le chinois). On montre alors le portrait seul, comme
         le fait le fournisseur lui-meme. Le titre de survol reste vide plutot
         que faux. */
      var zp = racine.querySelector('[data-persos]');
      if (data.tuiles) {
        /* Tuiles, comme le fournisseur : portrait carre, nom dessous coupe a
           une ligne, bordure a la couleur de la rarete. Avec 262 champions
           c'est la seule mise en page qui tienne a l'ecran, et le champ de
           recherche compense les noms tronques. */
        zp.classList.add('arc__puces--tuiles');
        zp.innerHTML = vedettes.map(function (id) {
          var n = nom(id);
          var col = couleur(id);
          return '<button type="button" class="arc__tuile" data-p="' + id + '"' +
                 (col ? ' style="--arc-r:' + col + '"' : '') +
                 ' aria-pressed="false" title="' + n + '">' +
                 img(id, 'arc__tuile-img') + '<span>' + (n || '&nbsp;') + '</span></button>';
        }).join('');
      } else {
        if (!vedettes.some(function (id) { return nom(id); })) zp.classList.add('arc__puces--portraits');
        zp.innerHTML = vedettes.map(function (id) {
          var n = nom(id);
          var v = versionDe[id];
          return '<button type="button" class="arc__puce arc__puce--perso' + (n ? '' : ' arc__puce--seule') + (v ? ' arc__puce--recent' : '') +
                 '" data-p="' + id + '" aria-pressed="false">' +
                 img(id, 'arc__icone') + (n ? '<span>' + n + '</span>' : '') +
                 (v ? '<em class="arc__ver">' + v + '</em>' : '') + '</button>';
        }).join('');
      }
      /* Au-dela d'une soixantaine de personnages (Raid en a 262), la liste
         devient une zone deroulante avec un champ de recherche : sinon elle
         occupe plusieurs ecrans avant le premier compte. */
      var chercher = racine.querySelector('[data-chercher]');
      if (vedettes.length > 60) {
        zp.classList.add('arc__puces--longue');
        chercher.hidden = false;
        chercher.addEventListener('input', function () {
          var q = chercher.value.trim().toLowerCase();
          zp.querySelectorAll('[data-p]').forEach(function (b) {
            var n = nom(+b.dataset.p).toLowerCase();
            /* Un personnage selectionne reste visible : sinon on ne peut plus
               le deselectionner apres avoir tape autre chose. */
            b.hidden = q && n.indexOf(q) < 0 && b.getAttribute('aria-pressed') !== 'true';
          });
        });
      }

      zp.addEventListener('click', function (e) {
        var b = e.target.closest('[data-p]'); if (!b) return;
        var id = +b.dataset.p, i = etat.persos.indexOf(id);
        if (i < 0) etat.persos.push(id); else etat.persos.splice(i, 1);
        b.setAttribute('aria-pressed', i < 0 ? 'true' : 'false');
        etat.page = 1; rendre();
      });
      if (data.armes) {
        var za = racine.querySelector('[data-armes]'), ca = racine.querySelector('[data-chercher-a]');
        var armes = data.armes.slice().sort(function (a, b) { return (dispo[b] || 0) - (dispo[a] || 0); })
          .filter(function (id) { return dispo[id]; });
        za.innerHTML = armes.map(function (id) {
          var n = nom(id);
          return '<button type="button" class="arc__puce arc__puce--perso' + (n ? '' : ' arc__puce--seule') + '" data-p="' + id + '" aria-pressed="false">' +
                 img(id, 'arc__icone') + (n ? '<span>' + n + '</span>' : '') + '</button>';
        }).join('');
        za.addEventListener('click', function (e) {
          var b = e.target.closest('[data-p]'); if (!b) return;
          var id = +b.dataset.p, i = etat.persos.indexOf(id);
          if (i < 0) etat.persos.push(id); else etat.persos.splice(i, 1);
          b.setAttribute('aria-pressed', i < 0 ? 'true' : 'false');
          etat.page = 1; rendre();
        });
        ca.addEventListener('input', function () {
          var q = ca.value.trim().toLowerCase();
          za.querySelectorAll('[data-p]').forEach(function (b) {
            b.hidden = q && nom(+b.dataset.p).toLowerCase().indexOf(q) < 0 && b.getAttribute('aria-pressed') !== 'true';
          });
        });
        racine.querySelector('.arc__onglets').addEventListener('click', function (e) {
          var o = e.target.closest('[data-onglet]'); if (!o) return;
          var a = o.dataset.onglet === 'a';
          racine.querySelectorAll('[data-onglet]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === o)); });
          zp.hidden = a; chercher.hidden = a || vedettes.length <= 60;
          za.hidden = !a; ca.hidden = !a;
        });
      }
      /* ?perso=Nom1,Nom2 dans l'adresse : ouvre le catalogue deja filtre (liens des fiches en rupture, 27/09/2026). */
      try {
        var arVoulus = (new URLSearchParams(location.search).get('perso') || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
        if (arVoulus.length) {
          var arTrouve = false;
          zp.querySelectorAll('[data-p]').forEach(function (b) { if (arVoulus.indexOf((nom(+b.dataset.p) || '').toLowerCase()) >= 0 && b.getAttribute('aria-pressed') !== 'true') { b.click(); arTrouve = true; } });
          if (arTrouve) setTimeout(function () { racine.scrollIntoView({ block: 'start' }); }, 400);
        }
      } catch (e) {}


      (data.groupes || []).forEach(function (g, i) {
        var z = racine.querySelector('[data-grp="' + i + '"]');
        z.innerHTML = '<button type="button" class="arc__puce" data-v="" aria-pressed="true">' + (g.vide || 'All') + '</button>' +
          g.valeurs.map(function (v) { return '<button type="button" class="arc__puce" data-v="' + v[0] + '" aria-pressed="false">' + v[1] + '</button>'; }).join('');
        z.addEventListener('click', function (e) {
          var b = e.target.closest('[data-v]'); if (!b) return;
          etat.grp[i] = b.dataset.v; etat.page = 1;
          z.querySelectorAll('[data-v]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          rendre();
        });
      });

      racine.querySelector('[data-tri]').addEventListener('change', function (e) { etat.tri = +e.target.value; etat.page = 1; rendre(); });
      racine.querySelector('[data-plus]').addEventListener('click', function () {
        var p = racine.querySelector('[data-panneauplus]');
        if (p.hasAttribute('data-ouvert')) p.removeAttribute('data-ouvert'); else p.setAttribute('data-ouvert', '');
      });
      racine.querySelector('[data-miniidx]').addEventListener('change', function (e) { etat.miniIdx = +e.target.value; etat.page = 1; rendre(); });
      racine.querySelector('[data-mini]').addEventListener('input', function (e) { etat.mini = parseInt(e.target.value, 10) || 0; etat.page = 1; rendre(); });
      window.addEventListener('scroll', majVoir, { passive: true });
      window.addEventListener('resize', majVoir);
      racine.querySelector('[data-voir]').addEventListener('click', function () {
        racine.querySelector('[data-total]').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      racine.querySelector('[data-raz]').addEventListener('click', function () {
        etat = neuf();
        racine.querySelectorAll('[data-p]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        racine.querySelectorAll('[data-grp] [data-v]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.v === '')); });
        racine.querySelector('[data-tri]').value = '0';
        racine.querySelector('[data-mini]').value = '';
        rendre();
      });

      racine.querySelector('[data-maj]').textContent = 'Stock updated ' + depuis(data.maj);
      rendre();
      complement();
    }

    /* Certains jeux ont trop de comptes pour un seul telechargement au
       chargement de la page (Raid en a des dizaines de milliers). Le fichier
       leger s'affiche tout de suite, le complet arrive derriere et remplace
       la liste sans rien casser. S'il est lent, trop lourd ou indisponible,
       il ne se passe RIEN : la page reste celle qui fonctionne deja. */
    function complement() {
      if (!data.plus || !base) return;
      /* L'empreinte de la moisson dans l'URL : sans elle le navigateur et le
         CDN resservent l'ancien fichier, qui ecrase alors le catalogue leger
         a jour par des donnees perimees. Les autres assets ont leur « ?v= »
         pose par Shopify, celui-ci est demande a la main. */
      var url = base + data.plus + '?v=' + encodeURIComponent(data.maj || '');
      var stop = setTimeout(function () { stop = null; }, 45000);
      fetch(url, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          if (!stop || !j || !Array.isArray(j.comptes) || j.comptes.length <= data.comptes.length) return;
          clearTimeout(stop);
          data.comptes = j.comptes;
          if (j.combos) data.combos = j.combos;
          if (j.persos) data.persos = j.persos;
          rendre();
        })
        .catch(function () { /* on garde le catalogue leger, c'est le but */ });
    }

    function rendre() {
      filtres = data.comptes.filter(function (c) {
        for (var g = 0; g < etat.grp.length; g++) if (etat.grp[g] && c[1][g] !== etat.grp[g]) return false;
        if (etat.mini && (c[2][etat.miniIdx] || 0) < etat.mini) return false;
        if (etat.persos.length) {
          var ids = champsDe(c).map(function (p) { return p[0]; });
          for (var i = 0; i < etat.persos.length; i++) if (ids.indexOf(etat.persos[i]) < 0) return false;
        }
        return true;
      });

      /* 15/10/2026 : plusieurs persos choisis = un compte qui les a TOUS. Odette + Lohen n'existe pas ensemble :
         « No account matches » faisait croire a une rupture. On montre alors les comptes qui en ont le plus. */
      var proches = 0;
      if (!filtres.length && etat.persos.length > 1) {
        var score = function (c) {
          var ids = champsDe(c).map(function (p) { return p[0]; }), n = 0;
          for (var i = 0; i < etat.persos.length; i++) if (ids.indexOf(etat.persos[i]) >= 0) n++;
          return n;
        };
        var base0 = data.comptes.filter(function (c) {
          for (var g = 0; g < etat.grp.length; g++) if (etat.grp[g] && c[1][g] !== etat.grp[g]) return false;
          return !(etat.mini && (c[2][etat.miniIdx] || 0) < etat.mini);
        });
        base0.forEach(function (c) { var n = score(c); if (n > proches) proches = n; });
        if (proches) filtres = base0.filter(function (c) { return score(c) === proches; });
      }
      etat.proches = proches;

      var t = (data.tris || [])[etat.tri];
      var k = t ? t[0] : 0;
      filtres.sort(function (a, b) { return (b[2][k] || 0) - (a[2][k] || 0); });

      var pages = Math.max(1, Math.ceil(filtres.length / parPage));
      if (etat.page > pages) etat.page = pages;

      racine.querySelector('[data-total]').textContent = proches
        ? 'No account has ' + (etat.persos.length === 2 ? 'both' : 'all ' + etat.persos.length) + ' together — ' + filtres.length.toLocaleString('en-US') +
          (filtres.length === 1 ? ' account has ' : ' accounts have ') + proches + ' of them'
        : filtres.length.toLocaleString('en-US') + (filtres.length === 1 ? ' account available' : ' accounts available');

      var actif = etat.persos.length || etat.mini || etat.grp.some(function (v) { return v; });
      racine.querySelector('[data-raz]').hidden = !actif;

      var grille = racine.querySelector('[data-grille]');
      grille.style.setProperty('--arc-stats', data.stats.length);
      if (data.disposition === 'lignes') grille.classList.add('arc__grille--lignes');
      grille.innerHTML = filtres.length
        ? filtres.slice((etat.page - 1) * parPage, etat.page * parPage).map(carte).join('')
        : (data.comptes.length
            ? '<div class="arc__vide">No account matches these filters. Try removing a character, or go back to the full list.</div>'
            /* Catalogue encore vide : c'est une mise a jour en cours, pas un
               filtre trop etroit. Le dire clairement evite de faire croire au
               visiteur qu'il a mal cherche. */
            : '<div class="arc__vide">Our stock list is being refreshed right now. The accounts will appear here shortly.</div>');

      pagination(pages);
      majVoir();
    }

    function majVoir() {
      var v = racine.querySelector('[data-voir]');
      if (!v) return;
      var actif = etat.persos.length || etat.mini || etat.grp.some(function (x) { return x; });
      var haut = racine.querySelector('[data-total]').getBoundingClientRect().top;
      v.textContent = filtres.length
        ? 'See the ' + filtres.length.toLocaleString('en-US') + (etat.proches ? ' closest' : '') + (filtres.length === 1 ? ' account' : ' accounts') + ' ↓'
        : 'No account matches ↓';
      v.hidden = !actif || haut < window.innerHeight - 80;
    }

    function carte(c) {
      /* `badge` designe le groupe qui merite la pastille foncee (le serveur
         pour Genshin, la plateforme pour One Piece) ; les autres suivent la
         reference, en petit. */
      var bi = (data.badge == null) ? 0 : data.badge;
      var badge = '', reste = [];
      (data.groupes || []).forEach(function (g, i) {
        var v = (g.valeurs.filter(function (x) { return x[0] === c[1][i]; })[0] || [])[1];
        if (!v) return;
        if (i === bi) badge = v; else reste.push(v);
      });

      /* 5 etoiles d'abord ; parmi eux, les personnages recents en premier (10/10/2026). */
      var rang = function (id) { return rangRecent[id] == null ? 999 : rangRecent[id]; };
      var persos = champsDe(c).slice().sort(function (a, b) { return rarete(b[0]) - rarete(a[0]) || rang(a[0]) - rang(b[0]); });
      var puces = data.tuiles
        /* Un compte Raid porte jusqu'a plusieurs centaines de champions : on
           ne met que le portrait, le nom reste au survol. */
        ? persos.map(function (p) {
            var col = couleur(p[0]);
            return '<span class="arc__tuile arc__tuile--nue"' + (col ? ' style="--arc-r:' + col + '"' : '') +
                   ' title="' + nom(p[0]) + '">' +
                   img(p[0], 'arc__tuile-img') + (p[1] ? '<em>x' + p[1] + '</em>' : '') + '</span>';
          }).join('')
        : persos.map(function (p) {
            var n = nom(p[0]);
            return '<span class="arc__p' + (haute(p[0]) ? ' arc__p--5' : '') + (versionDe[p[0]] ? ' arc__p--recent' : '') + (n ? '' : ' arc__p--seule') + '">' +
                   img(p[0], 'arc__icone arc__icone--p') +
                   (n ? '<span>' + n + '</span>' : '') +
                   (p[1] ? '<em>' + (n ? lettre : 'x') + p[1] + '</em>' : '') + '</span>';
          }).join('');

      var stats = data.stats.map(function (s, i) {
        return '<div class="arc__stat">' +
               '<b>' + iconeStat(i) + (c[2][i] === null ? '—' : (c[2][i] || 0).toLocaleString('en-US')) + '</b>' +
               '<span>' + s + '</span></div>';
      }).join('');

      var vid = c[4] ? (data.variantes || {})[c[4]] || vDefaut : vDefaut;

      return '<article class="arc__carte" data-ref="' + c[0] + '" data-v="' + vid + '">' +
        '<div class="arc__haut"><span class="arc__srv">' + badge + '</span>' +
          '<span class="arc__ref">' + (data.ref || '') + c[0] + (reste.length ? ' &middot; ' + reste.join(' &middot; ') : '') + '</span></div>' +
        '<div class="arc__stats">' + stats + '</div>' +
        '<div class="arc__persos' + (data.tuiles ? ' arc__persos--tuiles' : '') + '">' + puces + '</div>' +
        '<div class="arc__bas"><span class="arc__prix">' + (prixPar[vid] || '') + '</span>' +
          '<button type="button" class="arc__ajout" data-ajout>Add to cart</button></div>' +
      '</article>';
    }

    /* « img:<nom> » = vraie image du jeu (assets/ar-res-<nom>.png),
       « svg:<nom> » = icone dessinee ci-dessus. Rien = juste le chiffre. */
    function iconeStat(i) {
      var d = (data.statsIcones || [])[i];
      if (!d) return '';
      if (d.slice(0, 4) === 'img:') {
        return '<img class="arc__res" src="' + base + 'ar-res-' + d.slice(4) + '.png" alt="" loading="lazy" decoding="async" width="48" height="48" onerror="this.remove()">';
      }
      if (d.slice(0, 4) === 'svg:' && SVG[d.slice(4)]) {
        return '<svg class="arc__res" viewBox="0 0 24 24" aria-hidden="true">' + SVG[d.slice(4)] + '</svg>';
      }
      return '';
    }

    function pagination(pages) {
      var z = racine.querySelector('[data-pages]');
      if (pages < 2) { z.innerHTML = ''; return; }
      var p = etat.page, nums = [], i;
      for (i = Math.max(1, p - 2); i <= Math.min(pages, p + 2); i++) nums.push(i);
      z.innerHTML =
        '<button type="button" data-go="' + (p - 1) + '"' + (p === 1 ? ' disabled' : '') + '>Previous</button>' +
        (nums[0] > 1 ? '<button type="button" data-go="1">1</button>' + (nums[0] > 2 ? '<span>…</span>' : '') : '') +
        nums.map(function (n) { return '<button type="button" data-go="' + n + '"' + (n === p ? ' aria-current="true"' : '') + '>' + n + '</button>'; }).join('') +
        (nums[nums.length - 1] < pages ? (nums[nums.length - 1] < pages - 1 ? '<span>…</span>' : '') + '<button type="button" data-go="' + pages + '">' + pages + '</button>' : '') +
        '<button type="button" data-go="' + (p + 1) + '"' + (p === pages ? ' disabled' : '') + '>Next</button>' +
        '<span>Page ' + p + ' of ' + pages + '</span>';
    }

    /* --------------------------------------------------------- panier */

    racine.addEventListener('click', function (e) {
      var go = e.target.closest('[data-go]');
      if (go && !go.disabled) {
        etat.page = +go.dataset.go; rendre();
        racine.querySelector('[data-grille]').scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      var b = e.target.closest('[data-ajout]');
      if (!b) return;
      var art = b.closest('[data-ref]');
      var c = filtres.filter(function (x) { return String(x[0]) === art.dataset.ref; })[0];
      var vid = art.dataset.v;
      if (!c || !vid || vid === 'undefined') return;

      var props = { 'Account ID': (data.ref || '') + c[0] };
      (data.groupes || []).forEach(function (g, i) {
        var v = (g.valeurs.filter(function (x) { return x[0] === c[1][i]; })[0] || [])[1];
        if (v) props[g.titre.replace(/^Pick your /, '').replace(/^./, function (m) { return m.toUpperCase(); })] = v;
      });
      data.stats.forEach(function (s, i) { if (c[2][i] !== null) props[s] = String(c[2][i] || 0); });
      /* Sans les vignettes sans nom (arme connue seulement en chinois) : sinon « , , » dans la commande. */
      props.Characters = champsDe(c).filter(function (p) { return haute(p[0]) && nomLong(p[0]); })
        .map(function (p) { return nomLong(p[0]) + (p[1] ? ' ' + lettre + p[1] : ''); }).join(', ');

      b.disabled = true; b.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] }),
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { b.disabled = false; b.textContent = 'Try again'; });
    });
  }

  function depuis(iso) {
    var s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
    if (s < 120) return 'just now';
    if (s < 5400) return Math.round(s / 60) + ' minutes ago';
    if (s < 172800) return Math.round(s / 3600) + ' hours ago';
    return Math.round(s / 86400) + ' days ago';
  }
})();
